module.exports = __webpack_public_path__ + "static/media/AboutImg.e615e752.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-screen/AboutImg.jpg
// module id = 708
// module chunks = 0